import { FC, useMemo } from "react";

import { IBandXlsConfigParams, IIconBandSetting } from "Bands/types";
import { copy } from "shared/assets";
import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons } from "shared/types";
import { getFields } from "./formData";

const xlsCopy = copy.calendar.xlsExport;

interface Props {
  bandId: string;
  eventTypes: IIconBandSetting[];
  infoBlockTypes: IIconBandSetting[];
  apiStatus?: IAPIState;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  handleSubmit: (data: IBandXlsConfigParams) => void;
}

export const ExportXlsForm: FC<Props> = ({
  bandId,
  eventTypes,
  infoBlockTypes,
  apiStatus,
  hasError,
  defaultValues,
  handleSubmit,
}) => {
  const fields = useMemo(
    () =>
      getFields({
        bandId,
        eventTypes,
        infoBlockTypes,
      }),
    [bandId, eventTypes, infoBlockTypes]
  );

  const buttons = useMemo(
    (): IFormButtons => ({
      primary: {
        "data-testid": "save_xls_export",
        children: xlsCopy.buttons.save,
        size: "m",
      },
    }),
    []
  );

  return (
    <FormBuilder
      submitMode="isDirty"
      fields={fields}
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={hasError}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      neverGoBackToDefaultValues
      buttons={buttons}
      dataTestId="export_xls_form"
    />
  );
};
